export default __webpack_public_path__ + "static/EN-2b053c6dac36d47a0ff1bf8c20636e67.jpg";